// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';
import stylePickerHtml from 'text!html/stylePicker.html';
import 'myWorld/base/util';
import 'corner';
import 'spectrum';
import 'jquery-ui';
import 'myWorld/base/svgRenderer';

const stylePicker = {
    //Default style strings
    //ENH: get these as an option (needs convertion to class/object instead of singleton)
    defaultPointStyle: 'circle:green:4:green',
    defaultLineStyle: 'green:2:solid',
    defaultFillStyle: 'green:40',

    /**
     * Adds event handlers for the style picker form and the colour picker library(spectrum).
     * @class Style picker for configuring vector layer features.
     * @param  {string} [urlBase='']  Relative base url to be used when loading css and html files
     */
    initialize(urlBase = '') {
        if (!this.initialized) {
            this.urlBase = urlBase;
            this.symbol_names = Object.keys(myw.svgRenderer.symbols);
            let cssLoadPromise, messagesLoadPromise;

            messagesLoadPromise = myw.localisation.loadNamespace('myw.config'); // includes style picker messages

            //ensure css and initialize the dialog (loading its html) before proceding
            this.initialized = Promise.all([cssLoadPromise, messagesLoadPromise]).then(() => {
                this._initStylePickerDialog();
                this._initColourPicker();
                this._initEventHandlers();
            });
        }
        return this.initialized;
    },

    _initEventHandlers() {
        // On click event to open up a dropdown
        $('#stylePickerDialog').on('click', '.ui-selectmenu-button', function(event) {
            event.stopPropagation();
            $('.sp-container').toggleClass('sp-hidden', true); //Hide any open colour pickers
            $('.ui-selectmenu-active').removeClass('ui-selectmenu-active');
            $(this)
                .parent()
                .addClass('ui-selectmenu-active'); //helps in selecting the dropdown item
            const dropdownMenu = $(this).next('.dropdown-menu');
            $(dropdownMenu).toggle();
        });

        // On selecting the item in the dropdown element
        $('#stylePickerDialog').on(
            'click',
            '.input-dropdown.ui-selectmenu-active > ul > li',
            function() {
                const selectedSymbol = $(this).html();
                $('.input-dropdown.ui-selectmenu-active .selected-dropdown-item').html(
                    selectedSymbol
                );
                $(this)
                    .parent()
                    .hide();
            }
        );

        // Hides the dropdowns if a click outside it is detected
        $('#stylePickerDialog').click(() => {
            $('.ui-selectmenu-button')
                .next('.dropdown-menu')
                .hide();
        });

        // Event handler for showing and hiding the point style types controlled by radio buttons
        $("#point-style-config input:radio[name='point-style-type']").change(function() {
            if ($(this).is(':checked') && $(this).val() == 'point-bitmap') {
                $('.point-symbol-config').hide();
                $('.point-bitmap-config').fadeIn('slow');
            } else {
                $('.point-bitmap-config').hide();
                $('.point-symbol-config').fadeIn('slow');
            }
        });
    },

    /**
     * Adds the stylePickerDialog to the jquery ui dialog
     * Configures dialog button and event handlers
     * Sets the options for the dialog
     */
    _initStylePickerDialog() {
        if ($('#stylePickerDialog').dialog) {
            $('#stylePickerDialog').dialog('destroy');
            $('#stylePickerDialog').remove();
        }
        const self = this;
        const div = (this.stylePickerDialog = $('<div id="stylePickerDialog">'));

        $(':root').append(div);

        //Since style picker is also used in the config pages, Bootstrap button conflicts with jquery ui button
        //In that case make sure jquery-ui buttons are used.
        if ($.fn.button && $.fn.button.noConflict) {
            const btn = $.fn.button.noConflict(); // reverts $.fn.button to jqueryui btn
            $.fn.btn = btn; // assigns bootstrap button functionality to $.fn.btn
        }

        //load html from file
        div.html(stylePickerHtml);
        //translate messages
        myw.translate('StylePicker', div);
        //open as a dialog
        const dialogDiv = div.dialog({
            modal: true,
            autoOpen: false,
            width: 'auto',
            height: 'auto',
            resizable: true,
            position: { my: 'center', at: 'top+350', of: window },
            title: '',
            closeText: myw.msg('StylePicker', 'close_tooltip'),
            buttons: {
                Delete: {
                    text: myw.msg('StylePicker', 'delete_btn'),
                    class: 'js-btn-delete',
                    click() {
                        $(this).dialog('close');
                        self.deleteStyle();
                    }
                },
                Cancel: {
                    text: myw.msg('StylePicker', 'cancel_btn'),
                    click() {
                        $(this).dialog('close');
                    }
                },
                OK: {
                    text: myw.msg('StylePicker', 'ok_btn'),
                    click() {
                        const msg = self.checkValid();
                        if (msg) {
                            self.showMsg(msg);
                        } else {
                            $(this).dialog('close');
                            self.updateStyles();
                        }
                    }
                }
            }
        });

        this.dialogDiv = dialogDiv.parent();
        this.dialogDiv
            .find('.ui-dialog-buttonset')
            .css('float', 'none')
            .find('button:not(:first)')
            .css('float', 'right');

        this.symbol_names.forEach(symbol => {
            const svg = myw.svgRenderer.render(symbol);
            svg.style.height = '16px';
            svg.style.width = '16px'; //fixes alignment in ie
            svg.style.transform = 'rotate(180deg)';

            div.find('#point-style-symbol .dropdown-menu').append(
                $('<li/>', {
                    id: `symbol-${symbol}`,
                    html: $('<div/>', {
                        class: symbol,
                        html: svg
                    })
                })
            );
        });
    },

    /** Shows error message of the dialog */
    showMsg(msg) {
        const div = this.stylePickerDialog.parent().find('#stylepicker-error');
        div.find('.alert-text').html(msg);
        div.on('click', '.cancelAlert', () => {
            div.fadeOut(500);
        });
        div.find('.alert-message').show();
        div.show();
    },

    /**
     * Applies the 'spectrum' colour picker to all the elements with class 'colour-picker'
     */
    _initColourPicker() {
        // Apply the spectrum js colour picker to all the colour picker elements
        $('.colour-picker').spectrum({
            showInput: true,
            showInitial: true,
            showPalette: true,
            showSelectionPalette: true,
            clearText: myw.msg('StylePicker', 'clear_selection'),
            noColorSelectedText: myw.msg('StylePicker', 'no_colour_selected'),
            maxPaletteSize: 10,
            preferredFormat: 'hex',
            chooseText: myw.msg('StylePicker', 'ok_btn'),
            cancelText: myw.msg('StylePicker', 'cancel_btn'),
            appendTo: '#stylePickerDialog', // If this isn't added to the options, the input doesn't work with bootstrap modal
            change: colour => {
                const hex = colour !== null ? colour.toHexString() : '',
                    alpha = colour !== null ? colour._a : '1';
                //update the color blob in the form
                $('.colour-picker-active .picked-colour-blob').css({
                    'background-color': hex,
                    opacity: alpha
                });
                if (colour === null) {
                    $('.colour-picker-active .picked-colour-blob').css({
                        border: 'none',
                        'vertical-align': 'top'
                    });
                    $('.colour-picker-active .picked-colour-blob').html(
                        `<div class='myw-picker-no-colour'>${myw.msg(
                            'StylePicker',
                            'no_colour'
                        )}</div>`
                    );
                } else {
                    $('.colour-picker-active .picked-colour-blob').css({
                        border: '1px solid #ccc',
                        'vertical-align': 'text-top'
                    });
                    $('.colour-picker-active .picked-colour-blob').html('');
                }
            },
            show() {
                // Assigns the colour-picker-active class to the current colour-picker
                $('.colour-picker-active').removeClass('colour-picker-active');
                $(this).addClass('colour-picker-active');
                $('#stylePickerDialog')
                    .find('.dropdown-menu')
                    .hide(); //Hide any other open drodowns
            },
            palette: [
                ['#fff', '#f00', '#f90', '#ff0', '#0f0', '#0ff', '#00f', '#90f', '#f0f'],
                [
                    '#eee',
                    '#f4cccc',
                    '#fce5cd',
                    '#fff2cc',
                    '#d9ead3',
                    '#d0e0e3',
                    '#cfe2f3',
                    '#d9d2e9',
                    '#ead1dc'
                ],
                [
                    '#ccc',
                    '#ea9999',
                    '#f9cb9c',
                    '#ffe599',
                    '#b6d7a8',
                    '#a2c4c9',
                    '#9fc5e8',
                    '#b4a7d6',
                    '#d5a6bd'
                ],
                [
                    '#999',
                    '#e06666',
                    '#f6b26b',
                    '#ffd966',
                    '#93c47d',
                    '#76a5af',
                    '#6fa8dc',
                    '#8e7cc3',
                    '#c27ba0'
                ],
                [
                    '#666',
                    '#c00',
                    '#e69138',
                    '#f1c232',
                    '#6aa84f',
                    '#45818e',
                    '#3d85c6',
                    '#674ea7',
                    '#a64d79'
                ],
                [
                    '#444',
                    '#900',
                    '#b45f06',
                    '#bf9000',
                    '#38761d',
                    '#134f5c',
                    '#0b5394',
                    '#351c75',
                    '#741b47'
                ],
                [
                    '#000',
                    '#600',
                    '#783f04',
                    '#7f6000',
                    '#274e13',
                    '#0c343d',
                    '#073763',
                    '#20124d',
                    '#4c1130'
                ]
            ]
        });
    },

    /**
     * Creates the html elements that form a point style picker
     * The returned element will trigger the 'style-changed' event with the new style as an argument
     * @param  {string} pointStyle Initial style
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * @return {jQueryElement}            A jQuery object for the top-level element of the newly create style picker
     */
    createPointStylePicker(pointStyle, simplified) {
        return this.createStyleCell(
            'point',
            pointStyle,
            this.buildPointStyle(pointStyle, simplified)
        );
    },
    /**
     * Creates the html elements that form a line style picker
     * @param  {string} lineStyle Initial style
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * The returned element will trigger the 'style-changed' event with the new style as an argument
     * @return {jQueryElement}            A jQuery object for the top-level element of the newly create style picker
     */
    createLineStylePicker(lineStyle, simplified) {
        return this.createStyleCell('line', lineStyle, this.buildLineStyle(lineStyle, simplified));
    },
    /**
     * Creates the html elements that form a polygon style picke
     * @param  {string} lineStyle   Initial line style
     * @param  {string} fillStyle   Initial fill style
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * The returned element will trigger the 'style-changed' event with the new style as an argument
     * @return {jQueryElement}            A jQuery object for the top-level element of the newly create style picker
     */
    createPolygonStylePicker(lineStyle, fillStyle, simplified) {
        const polygonStyle = `${lineStyle};${fillStyle}`;
        return this.createStyleCell(
            'polygon',
            polygonStyle,
            this.buildPolygonStyle(lineStyle, fillStyle, simplified)
        );
    },
    /**
     * Creates the html elements that form a text style picker
     * @param  {string} textStyle   Initial style
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * @return {jQueryElement}            A jQuery object for the top-level element of the newly create style picker
     */
    createTextStylePicker(textStyle, simplified) {
        textStyle = textStyle || null;
        return this.createStyleCell('text', textStyle, this.buildTextStyle(textStyle, simplified));
    },

    createDisabledStylePicker() {
        // EHN create style picker box that is greyed out
        return $('<span>');
    },

    /**
     * Creates the content for the style cell with an edit button | [style representation]   | [edit button] |
     * @param  {string}         type            Feature geometry type
     * @param  {string}         styleString     String containing the style attributes
     * @param  {string|jQueryElement|Array<jQueryElement>}         styleNode       Style representation
     * @return {jQueryElement}                  Style cell content with an edit button
     */
    createStyleCell(type, styleString, styleNode) {
        const styleInputNode = $("<span class='emulate-input'></span>"),
            styleContentNode = $("<span class='style-input'></span>"),
            styleEditAddon = $(
                `<span class='emulate-input-addon icon-pencil ${type}-style-edit'></span>`
            ),
            container = $('<span>'),
            self = this;

        // On clicking the EDIT STYLE button
        styleEditAddon.on('click', function() {
            self.openStyleDialog(this);
        });

        styleInputNode.attr('data', styleString);

        styleContentNode.addClass(`layer-edit-field-feature-${type}-style`);

        container.append(styleInputNode).append(styleEditAddon);
        styleInputNode.append(styleContentNode);
        styleContentNode.append(styleNode);

        return container;
    },

    /**
     * Creates a symbol to represent the point style in the colour specified
     * @param  {string}      ps String containing point style attributes [symbol:colour:size]
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * @return {jQueryElement}    HTML representation of the style string 'ps'
     */
    buildPointStyle(ps, simplified) {
        const styles = ps.split(':'),
            symbolName = styles[0],
            symbolColour = styles[1],
            symbolBorderColor = styles[3],
            pointStyleSymbol = $('<span class="in-emulate-input"></span>');

        if (myw.svgRenderer.symbols[symbolName]) {
            const svg = myw.svgRenderer.render(symbolName);
            svg.style.height = '20px';
            svg.style.width = '20px'; //fixes ie alignment
            svg.style.fill = symbolColour.length == 0 ? 'transparent' : symbolColour;
            svg.style.transform = 'rotate(180deg)';
            if (symbolBorderColor) {
                svg.style.stroke =
                    symbolBorderColor.length == 0 ? 'transparent' : symbolBorderColor;
                svg.style.strokeWidth = '5px';
            }
            $(pointStyleSymbol).html(svg);
        } else {
            $(pointStyleSymbol).text(ps);
        }

        if (simplified) {
            $('.point-style-type').hide();
            $('#point-style-config table').css('margin-left', '0px');
        }

        return $(pointStyleSymbol);
    },

    /**
     * Creates a line to represent the line style
     * The line matches the dash type, arrow type and the colour of the style
     * @param  {string}      ls   String containing line style attributes [colour:size:dash-type]
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * @return {string}      HTML representation of the style string 'ls'
     */
    buildLineStyle(ls, simplified) {
        const styles = ls.split(':'),
            linePattern = !styles[2] ? 'solid' : styles[2],
            lineColour = styles[0] === '' ? 'transparent' : styles[0],
            lineStyleSymbol = $($(`.line-${linePattern}`).html())
                .css('border-bottom-color', lineColour)
                .prop('outerHTML'),
            lineBeginArrow =
                styles[3] === 'arrow'
                    ? $("<span class='arrow-left'></span>")
                          .css('border-right-color', lineColour)
                          .prop('outerHTML')
                    : '',
            lineEndArrow =
                styles[4] === 'arrow'
                    ? $("<span class='arrow-right'></span>")
                          .css('border-left-color', lineColour)
                          .prop('outerHTML')
                    : '';

        //Assign line style symbol when undefined
        let temp = '';
        if (!lineStyleSymbol)
            temp = '<span class="solid-line" style="border-bottom-color: rgb(0, 128, 0);"></span>';
        else temp = lineStyleSymbol;
        return lineBeginArrow + temp + lineEndArrow;
    },
    /**
     * Creates a rectangle to show the fill colour and opacity of the polygon style
     * The rectangle has a border to represent the polygon border colour if any.
     * @param  {string} ls   String containing border style attributes [dash-type:colour:size]
     * @param  {string} fs   String containing fill style attributes [colour:opacity]
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * @return {jQueryElement} HTML representation of the style strings 'ls' and 'fs'
     */
    buildPolygonStyle(ls, fs, simplified) {
        const fillColour = fs ? fs.split(':')[0] : '#000000';
        const fillOpacity = fs ? fs.split(':')[1] / 100 : '0';
        const polygonBorderColour = ls ? (!ls.split(':')[0] ? '' : ls.split(':')[0]) : '#000000';

        const polygonRepContainer = $("<span class='polygon-rep-container'></span>");
        const polygonStyleSymbol = $(
            '<span class="in-emulate-input polygon-representation"></span>'
        );

        if (polygonBorderColour === '') {
            polygonRepContainer.css({ height: '15px', border: 'none' });
        } else {
            polygonRepContainer.css('height', '13px');
        }

        $(polygonRepContainer).css('border-color', polygonBorderColour);
        $(polygonStyleSymbol).css({ 'background-color': fillColour, opacity: fillOpacity });

        if (!ls && !fs) {
            $(polygonRepContainer).css('display', 'none');
            $(polygonStyleSymbol).css('display', 'none');
        }

        $(polygonRepContainer).append(polygonStyleSymbol);

        return $(polygonRepContainer);
    },
    /**
     * Creates a label to represent the text style
     * The label contains the attribute name in the colour specified
     * The label has a background and border to represent the background and border colour in the text style
     * @param  {string}      ts String containing text style attributes [attrib_name:colour:size:v_just:h_just:background colour:border-width]
     * @param  {Boolean} simplified Indicates that a simplified version of the picker should be display
     * @return {jQueryElement}    HTML representation of the style string 'ts'
     */
    buildTextStyle(ts, simplified) {
        const labelContainer = $("<span class='label-rep-container'></span>"),
            label = $('<span class="in-emulate-input label-representation"></span>');
        if (ts) {
            const styles = ts.split(':');
            const labelAttr = styles[0];
            $(label).text(labelAttr);
            $(label).css('color', styles[1]);

            const borderWidth = styles[6] || '';
            if (!!borderWidth && borderWidth !== '0')
                $(labelContainer).css('border-color', styles[1]);

            $(label).css('background-color', styles[5]);
        }

        $(labelContainer).append(label);

        if (simplified) $('#text-attribute-name').hide();

        return $(labelContainer);
    },

    /**
     * Opens the appropriate style picker dialog
     * @param  {domElement} cellEditIcon The edit button clicked to spawn the style picker dialog
     */
    openStyleDialog(cellEditIcon, onChange, includeZoomInformation = false) {
        this.onChange = onChange;
        const cellEditIconObj = $(cellEditIcon),
            cellToEdit = cellEditIconObj.parent();

        if (cellToEdit.hasClass('layer-edit-grey')) return;

        this.currentCell = cellToEdit;

        const styleCell = cellEditIconObj.parent(),
            featureRow = $(styleCell).parent()[0];

        $('#stylePickerDialog .style-form').hide();

        // Update the dialog header
        const header = $(featureRow)
            .children('.layer-edit-field-feature-full-name')
            .html();
        $('#stylePickerDialog #header-feature-external-name').text(header);

        // Get the styles from the style string
        let styleString = styleCell.find('.emulate-input').attr('data');

        if (cellEditIconObj.hasClass('point-style-edit')) {
            styleString = this.toggleDeleteButton(this.defaultPointStyle, styleString);
            this.createPointStyleDialog(header, styleString);
        } else if (cellEditIconObj.hasClass('line-style-edit')) {
            styleString = this.toggleDeleteButton(this.defaultLineStyle, styleString);
            this.createLineStyleDialog(header, styleString, $('#line-style-config'));
            $('#line-style-config').show();
        } else if (cellEditIconObj.hasClass('polygon-style-edit')) {
            styleString = this.toggleDeleteButton(
                `${this.defaultLineStyle};${this.defaultFillStyle}`,
                styleString
            );
            this.createPolygonStyleDialog(header, styleString);
        } else if (cellEditIconObj.hasClass('text-style-edit')) {
            this.toggleDeleteButton('', styleString);
            this.createTextStyleDialog(header, styleString, includeZoomInformation);
        }

        $.ui.dialog.prototype._focusTabbable = () => {}; // Avoids the autofocus to the first input element on open
        $('#stylePickerDialog').dialog('open');
    },

    /**
     * toggles the delete button on the overlay. depends on the styleString value
     * @param defaultStyle default style for the layer feature style (optional)
     * @param styleString passes the current data attribute value
     * @returns {*} returns style value
     */
    toggleDeleteButton(defaultStyle, styleString) {
        if (!styleString) {
            styleString = defaultStyle;
            $('.ui-dialog button.js-btn-delete').hide();
        } else {
            $('.ui-dialog button.js-btn-delete').show();
        }
        return styleString;
    },

    /**
     * Updates the point style dialog with the values in the 'pointStyleString'
     * @param  {string} pointStyleString Style string with all the point styles separated by ":"
     */
    createPointStyleDialog(header, pointStyleString) {
        let title = myw.msg('StylePicker', 'point_style');
        if (header) title = `${header}: ${title}`;
        $('#stylePickerDialog').dialog('option', 'title', title);
        const pointSizeRow = $('#point-size-row');
        const pointColourPicker = $('#point-style-colour-picker');
        const pointBorderPicker = $('#point-style-border-colour-picker');
        const pointStyles = this.splitPointStyleString(pointStyleString.trim());
        let pointColour = '#000000';
        let pointBorderColor = '#000000';
        let pointSize = [];
        const isSymbol =
            pointStyleString.split('/').length === 1 &&
            _.contains(this.symbol_names, pointStyles[0]);

        //reset as they hang around if not
        $('#point-bitmap input').val('');
        $('.point-bitmap-config-x input').val('');
        $('.point-bitmap-config-y input').val('');

        // Figure out if the point style string is a symbol or a bitmap
        if (!pointStyleString.trim() || isSymbol) {
            // Show the symbol styles form
            $('.point-bitmap-config').hide();
            $('.point-symbol-config').show();
            pointColour = !pointStyleString.trim() ? pointColour : pointStyles[1];
            pointBorderColor = !pointStyleString.trim()
                ? pointBorderColor
                : pointStyles[3] || pointColour;
            pointSize = !pointStyleString.trim() ? [] : pointStyles[2].split('m');

            let pointColourBlobHtml = '';
            let borderColourBlobHtml = '';
            let pointFillborder = '1px solid #ddd';
            let pointBorderborder = '1px solid #ddd';
            //display 'None' on picker when no colour selected
            if (pointColour.length === 0) {
                pointColourBlobHtml = `<div class='myw-picker-no-colour'>${myw.msg(
                    'StylePicker',
                    'no_colour'
                )}</div>`;
                pointFillborder = 'none';
            }
            if (pointBorderColor === '') {
                borderColourBlobHtml = `<div class='myw-picker-no-colour'>${myw.msg(
                    'StylePicker',
                    'no_colour'
                )}</div>`;
                pointBorderborder = 'none';
            }
            pointColourPicker
                .find('.picked-colour-blob')
                .html(pointColourBlobHtml)
                .css({ border: pointFillborder });
            pointBorderPicker
                .find('.picked-colour-blob')
                .html(borderColourBlobHtml)
                .css({ border: pointBorderborder });
            // Symbol
            $('#point-style-symbol-selected').html($(`#symbol-${pointStyles[0]}`).html());
            // Size
            pointSizeRow.find("input[type='text']").val(pointSize[0]);
            // Select the 'world units' radio button if the size has an 'm' appended to it
            pointSizeRow.find("input[value='px']").prop('checked', pointSize.length <= 1);
            pointSizeRow.find("input[value='world units']").prop('checked', pointSize.length > 1);

            $("#point-style-config input:radio[value='point-symbol']").prop('checked', true);
        } else {
            // Reset size input
            //pointSizeRow.find("input[type='text']").val("");
            // show the Image style form
            $('.point-symbol-config').hide();
            $('.point-bitmap-config').show();

            const pointBitmapFile = pointStyles[0];
            const pointBitmapX = pointStyles[1];
            const pointBitmapY = pointStyles[2];
            const pointSize = pointStyles.length < 4 ? [] : pointStyles[3].split('m');
            $('#point-bitmap input').val(pointBitmapFile);
            $('.point-bitmap-config-x input').val(pointBitmapX);
            $('.point-bitmap-config-y input').val(pointBitmapY);

            $('#point-bitmap-size-row')
                .find("input[type='text']")
                .val(pointSize[0]);
            // Select the 'world units' radio button if the size has an 'm' appended to it
            $('#point-bitmap-size-row')
                .find("input[value='px']")
                .prop('checked', pointSize.length <= 1);
            $('#point-bitmap-size-row')
                .find("input[value='world units']")
                .prop('checked', pointSize.length > 1);

            $("#point-style-config input:radio[value='point-bitmap']").prop('checked', true);
        }
        // Set colour
        pointColourPicker.children('.picked-colour-blob').css('background-color', pointColour);
        pointColourPicker.spectrum('set', pointColour);
        pointBorderPicker.children('.picked-colour-blob').css('background-color', pointBorderColor);
        pointBorderPicker.spectrum('set', pointBorderColor);
        $('#point-style-config').show();
    },

    /**
     *   Splits point style string ensuring http(s) prefixes are preserved for images
     */
    splitPointStyleString(str) {
        let prefix = '';
        const regexp = /(http|https):\/\//;
        const match = str.match(regexp);

        if (match) prefix = match[0];

        const splitStyle = str.replace(prefix, '').split(':');
        if (!prefix.length) return splitStyle;

        splitStyle[0] = prefix + splitStyle[0];
        return splitStyle;
    },

    /**
     * Updates the line style dialog with the values in the 'lineStyleString'
     * @param  {string} lineStyleString Style string with all the line styles separated by ":"
     */
    createLineStyleDialog(header, lineStyleString, lineStyleContainer) {
        let title = myw.msg('StylePicker', 'line_style');
        if (header) title = `${header}: ${title}`;
        $('#stylePickerDialog').dialog('option', 'title', title);
        const lineColourPicker = lineStyleContainer.find('.line-style-colour-picker');
        const lineSizeRow = lineStyleContainer.find('.line-size-row');
        let lineStyles = [];
        let pattern = 'solid';
        let lineColour = '#000000';
        let lineSize = [];
        let lineBeginArrow = 'none';
        let lineEndArrow = 'none';
        let colourBlobHtml;
        let colour;
        let border;

        if (lineStyleString.trim()) {
            // if the line style string exists
            lineStyles = lineStyleString.split(':');
            pattern = lineStyles.length > 2 ? lineStyles[2] : pattern;
            lineColour = lineStyles[0];
            lineSize = lineStyles[1].split('m');
            lineBeginArrow = lineStyles[3];
            lineEndArrow = lineStyles[4];
        }
        // Pattern
        $('.line-style-pattern-selected').html($(`.line-${pattern}`).html());
        // Colour
        if (lineColour === '') {
            colourBlobHtml = `<div class='myw-picker-no-colour'>${myw.msg(
                'StylePicker',
                'no_colour'
            )}</div>`;
            border = 'none';
        } else {
            colourBlobHtml = '';
            border = '1px solid #ddd';
        }
        lineColourPicker
            .children('.picked-colour-blob')
            .css({ 'background-color': lineColour, border: border });
        lineColourPicker.children('.picked-colour-blob').html(colourBlobHtml);
        lineColourPicker.spectrum('set', lineColour);
        // Size
        const lineWidth = lineSize[0] === '' ? '1' : lineSize[0];
        lineSizeRow.find("input[type='text']").val(lineWidth);
        // Select the 'world units' radio button if the size has an 'm' appended to it
        lineSizeRow.find("input[value='px']").prop('checked', true);
        lineSizeRow.find("input[value='world units']").prop('checked', lineSize.length > 1);

        const beginArrowHtml =
            lineBeginArrow === 'arrow'
                ? $('.arrow-begin').prop('outerHTML')
                : $('.arrow-none').prop('outerHTML');
        $('#arrow-begin-style-selected').html(beginArrowHtml);

        const endArrowHtml =
            lineEndArrow === 'arrow'
                ? $('.arrow-end').prop('outerHTML')
                : $('.arrow-none').prop('outerHTML');
        $('#arrow-end-style-selected').html(endArrowHtml);
    },

    /**
     * Updates the fill style dialog with the values in the 'fillStyleString'
     * @param  {string} fillStyleString Style string with all the fill styles separated by ":"
     */
    createPolygonStyleDialog(header, polygonStyleString) {
        const fillStyleString = polygonStyleString.split(';')[1],
            lineStyleString = polygonStyleString.split(';')[0];

        this.createLineStyleDialog(header, lineStyleString, $('#polygon-style-config'));

        let title = myw.msg('StylePicker', 'polygon_style');

        if (header) title = `${header}: ${title}`;
        $('#stylePickerDialog').dialog('option', 'title', title);
        const fillStyles = fillStyleString.split(':');
        const fillColourPicker = $('#polygon-style-colour-picker');
        const fillOpacity = !fillStyleString.trim() ? '' : fillStyles[1] / 100;
        let colourBlobHtml;
        let fillColour;
        let border;

        if (fillStyleString === '#000000:0') {
            colourBlobHtml = `<div class='myw-picker-no-colour'>${myw.msg(
                'StylePicker',
                'no_colour'
            )}</div>`;
            fillColour = 'transparent';
            border = 'none';
        } else {
            colourBlobHtml = '';
            fillColour = fillStyles[0];
            border = '1px solid #ddd';
            fillColourPicker.find('.picked-colour-blob').css('opacity', fillOpacity);
        }
        fillColourPicker
            .find('.picked-colour-blob')
            .css({ 'background-color': fillColour, border: border });
        fillColourPicker.find('.picked-colour-blob').html(colourBlobHtml);

        fillColour = fillColourPicker.find('.picked-colour-blob').css('background-color');
        let rgbObj;

        if (fillColour === '') rgbObj = { r: 0, g: 0, b: 0, a: 0 };
        else {
            // Convert the fillColour to hex and then to RGB to get the proper object format
            fillColour = fillColour[0] !== '#' ? this.rgbToHex(fillColour) : fillColour;
            rgbObj = this.hexToRgb(fillColour);
            rgbObj.a = fillStyles[1] / 100 || 0; // Since the string has the fill opacity in percent
        }

        fillColourPicker.spectrum('set', rgbObj);
        $('#polygon-style-config').show();
    },

    /**
     * Updates the text style dialog with the values in the 'textStyleString'
     * @param  {string} textStyleString Style string with all the text styles separated by ":"
     */
    createTextStyleDialog(header, textStyleString, includeZoomInformation) {
        let title = myw.msg('StylePicker', 'text_style');
        const textStyles = textStyleString !== undefined ? textStyleString.split(':') : [];

        if (header) title = `${header}:${title}`;
        $('#stylePickerDialog').dialog('option', 'title', title);
        const textSizeRow = $('#text-size-row'),
            textColourPicker = $('#text-style-colour-picker'),
            textVerticalAlignRow = $('#text-vertical-align'),
            textHorizontalAlignRow = $('#text-horizontal-align'),
            minVisRow = $('.min-vis'),
            maxVisRow = $('.max-vis'),
            textBackgroundColourPicker = $('#text-style-background-colour-picker');

        if (!includeZoomInformation) {
            $('#text-min-vis').remove();
        }

        //Get current limits of visibility selects
        const currentOptions = [];
        $('.min-vis option').each(function() {
            currentOptions.push($(this).val());
        });

        //Set lower and upper limits for label visibility selects (feature visibility is always inside layer visibility)
        const lowerLimit = parseInt(textStyles[9]) || parseInt(textStyles[11]) || currentOptions[1]; //currentOptions[0] is always &nbsp (null)
        const upperLimit =
            parseInt(textStyles[10]) ||
            parseInt(textStyles[12]) ||
            currentOptions[currentOptions.length - 1];

        //Add options to selects
        $('.vis_select').empty();
        $('.vis_select').append($('<option></option>').html('&nbsp'));
        for (let i = lowerLimit; i <= upperLimit; i++) {
            $('.vis_select').append(
                $('<option></option>')
                    .val(i)
                    .html(i)
            );
        }

        // Default style values
        let textColour = '#000000',
            textSize = ['12'],
            textVerticalAlign = $('#text-vertical-align select option:first').val(),
            textHorizontalAlign = $('#text-horizontal-align select option:first').val(),
            textVerticalOffset = '',
            textHorizontalOffset = '',
            textBackgroundColour = 'transparent',
            textBorderWidth = '',
            colourBlobHtml,
            border,
            min_vis = $('.min_vis').val(),
            max_vis = $('.max_vis').val();
        // Replacing the default values with values from the styleString
        if (textStyleString && !!textStyleString.trim()) {
            textColour = textStyles[1].length > 0 ? textStyles[1] : textColour;
            textSize = textStyles[2].split('m');
            textVerticalAlign = textStyles[3].split(/[+-]+/)[0];
            textHorizontalAlign = textStyles[4].split(/[+-]+/)[0];
            textVerticalOffset = this._getOffsetValue(textStyles[3]);
            textHorizontalOffset = this._getOffsetValue(textStyles[4]);
            textBackgroundColour = textStyles[5].length > 0 ? textStyles[5] : textBackgroundColour;
            textBorderWidth = textStyles[6];
            min_vis = textStyles[7] || '';
            max_vis = textStyles[8] || '';
        }
        if (_.isEqual(textSize, [''])) textSize = ['12'];

        // Attribute name
        const that = this;
        $('#text-attribute-name input').val(textStyles[0]);
        $('#text-attribute-name input').on('change', function() {
            that._checkDisabled($(this).val());
        });
        this._checkDisabled(textStyles[0]);

        // Colour
        textColourPicker.children('.picked-colour-blob').css('background-color', textColour);
        textColourPicker.spectrum('set', textColour);
        // Size
        textSizeRow.find("input[type='text']").val(textSize[0]);
        // Select the 'world units' radio button if the size has an 'm' appended to it
        textSizeRow.find("input[value='px']").prop('checked', textSize.length <= 1);
        textSizeRow.find("input[value='world units']").prop('checked', textSize.length > 1);
        // Vertical align
        textVerticalAlignRow.find('select').val(textVerticalAlign);
        textVerticalAlignRow.find('.offset-justification').val(textVerticalOffset);
        // Horizontal align
        textHorizontalAlignRow.find('select').val(textHorizontalAlign);
        textHorizontalAlignRow.find('.offset-justification').val(textHorizontalOffset);
        // Min/Max zoom level for label
        minVisRow.val(parseInt(min_vis));
        maxVisRow.val(parseInt(max_vis));
        // Background colour
        if (textBackgroundColour === 'transparent') {
            colourBlobHtml = `<div class='myw-picker-no-colour'>${myw.msg(
                'StylePicker',
                'no_colour'
            )}</div>`;
            border = 'none';
        } else {
            colourBlobHtml = '';
            border = '1px solid #ddd';
        }
        // Attribute name
        $('#text-attribute-name input').val(textStyles[0]);
        // Colour
        textBackgroundColourPicker
            .find('.picked-colour-blob')
            .html(colourBlobHtml)
            .css({ 'background-color': textBackgroundColour, border: border });
        textBackgroundColourPicker.spectrum('set', textBackgroundColour);
        // Border width
        $('#text-border-width')
            .find("input[type='text']")
            .val(textBorderWidth);

        $('#text-style-config').show();
    },

    /**
     * Gets the offset value to be added to the text style dialog form from the style string
     * @param  {string} justificationString Justification offset derived from the style string
     * @return {string}                     The offset value to be shown in the form input
     */
    _getOffsetValue(justificationString) {
        if (justificationString.split(/[+-]+/).length === 1) {
            return '';
        } else if (justificationString.split('+').length === 2) {
            return justificationString.split('+')[1];
        } else if (justificationString.split('-').length === 2) {
            return `-${justificationString.split('-')[1]}`;
        }
    },

    /**
     * Creates the offset string to be added to the vertical or horizontal justifications while creating the styleString
     * @param  {string} inputVal The value input in the offset field of the text style picker
     * @return {string}          The string to be added to the styleString
     */
    _getOffsetString(inputVal) {
        if (inputVal === '' || inputVal === '0') {
            return '';
        } else if (inputVal.split(/[+-]+/).length === 1) {
            return `+${inputVal}`;
        } else if (inputVal.split(/[+-]+/).length === 2) {
            return inputVal;
        }
    },

    /**
     * Converts rgb format to a hex colour
     * @param  {string} rgb Colour in RGB format
     * @return {string}     Hex conversion value for the RGB colour
     */
    rgbToHex(rgb) {
        if (rgb === 'transparent' || rgb === 'rgba(0, 0, 0, 0)') return '';
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return `#${`0${parseInt(rgb[1], 10).toString(16)}`.slice(-2)}${`0${parseInt(
            rgb[2],
            10
        ).toString(16)}`.slice(-2)}${`0${parseInt(rgb[3], 10).toString(16)}`.slice(-2)}`;
    },
    /**
     * Converts hex format to a rgb colour
     * @param  {string} hex Colour in Hex format
     * @return {string}     RGB conversion value for the Hex colour
     */
    hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : { r: 0, g: 0, b: 0 };
    },

    /**
     * Check validity of data entered on form
     */
    checkValid() {
        const selectedItem = this.currentCell.find('.emulate-input-addon');

        if (selectedItem.hasClass('text-style-edit')) {
            const value = $("#text-size-row input[type='text']").val();
            if (!parseFloat(value)) return myw.msg('StylePicker', 'invalid_text_size');
        }
        return '';
    },

    /**
     * Gathers up all the data updated in the style picker dialog to create a style string for the layer features table
     */
    updateStyles() {
        const selectedItem = this.currentCell.find('.emulate-input-addon'),
            container = selectedItem.parent();

        if (selectedItem.hasClass('point-style-edit')) {
            this.updatePointStyle(container);
        } else if (selectedItem.hasClass('line-style-edit')) {
            this.updateLineStyle(container);
        } else if (selectedItem.hasClass('polygon-style-edit')) {
            this.updatePolygonStyle(container);
        } else if (selectedItem.hasClass('text-style-edit')) {
            this.updateTextStyle(container);
        }
    },

    deleteStyle() {
        const selectedItem = this.currentCell.find('.emulate-input-addon'),
            container = selectedItem.parent();

        const pointStyleString = null;
        const emulateInputEle = container.find('.emulate-input');

        emulateInputEle.attr('data', pointStyleString);

        this.notify(pointStyleString, container);

        emulateInputEle.find('span.style-input span').hide();
    },

    updatePointStyleImageString(container) {
        const pointStyleElement = container.find('.layer-edit-field-feature-point-style').parent();
        const pointBitmapFile = $('.point-bitmap-config input').val(),
            pointBitmapX = $('.point-bitmap-config-x input').val(),
            pointBitmapY = $('.point-bitmap-config-y input').val(),
            pointSizeUnit =
                $('#point-bitmap-size-row')
                    .find("input[name='size-unit']:checked")
                    .val() === 'world units'
                    ? 'm'
                    : '',
            pointSymbolSize =
                $('#point-bitmap-size-row')
                    .find("input[type='text']")
                    .val() + pointSizeUnit;

        const pointStyleString = `${pointBitmapFile}:${pointBitmapX}:${pointBitmapY}:${pointSymbolSize}`;
        pointStyleElement.attr('data', pointStyleString);
        container.find('.layer-edit-field-feature-point-style').html(pointStyleString);
        this.notify(pointStyleString, container);
    },

    updatePointStyle(container) {
        if ($("#point-style-config input:radio[value='point-bitmap']").is(':checked')) {
            const pointBitmapFile = $('.point-bitmap-config input').val(),
                pointBitmapX = $('.point-bitmap-config-x input').val(),
                pointBitmapY = $('.point-bitmap-config-y input').val();

            if (pointBitmapX.length === 0 || pointBitmapY.length === 0) {
                // Styles created before version 2.5 did not have an anchor set, this is why we'll need to calculate an anchor point for them.
                // bottom-middle for backwards compatibility.
                const imgLoader = new Image();
                imgLoader.src = pointBitmapFile;

                $(imgLoader)
                    .on('load', () => {
                        $('.point-bitmap-config-x input').val(imgLoader.width / 2);
                        $('.point-bitmap-config-y input').val(imgLoader.height);
                        this.updatePointStyleImageString(container);
                    })
                    .on('error', () => {
                        //ENH: Add validation

                        //Couldn't find the image. Save it as it is.
                        this.updatePointStyleImageString(container);
                    });
            } else {
                this.updatePointStyleImageString(container);
            }
        } else {
            const pointSizeUnit =
                    $('#point-size-row')
                        .find("input[name='size-unit']:checked")
                        .val() === 'world units'
                        ? 'm'
                        : '',
                pointSymbolName = $('#point-style-symbol-selected > div').prop('class'),
                pointSymbolColour = this.rgbToHex(
                    $('#point-style-colour-picker .picked-colour-blob').css('background-color')
                ),
                pointSymbolBorderColour = this.rgbToHex(
                    $('#point-style-border-colour-picker .picked-colour-blob').css(
                        'background-color'
                    )
                ),
                pointSymbolSize =
                    $('#point-size-row')
                        .find("input[type='text']")
                        .val() + pointSizeUnit;

            // Update the style string in the point style table cell and fire an event with the updated string
            let pointStyleString = `${pointSymbolName}:${pointSymbolColour}:${pointSymbolSize}`;
            if (pointSymbolBorderColour) {
                pointStyleString += `:${pointSymbolBorderColour}`;
            }
            const pointStyleElement = container
                .find('.layer-edit-field-feature-point-style')
                .parent();
            pointStyleElement.attr('data', pointStyleString);
            this.notify(pointStyleString, container);

            if (myw.svgRenderer.symbols[pointSymbolName]) {
                const svg = myw.svgRenderer.render(pointSymbolName);
                svg.style.height = '20px';
                svg.style.width = '20px'; //fixes ie alignment
                svg.style.fill = pointSymbolColour.length == 0 ? 'transparent' : pointSymbolColour;
                svg.style.transform = 'rotate(180deg)';
                if (pointSymbolBorderColour) {
                    svg.style.stroke =
                        pointSymbolBorderColour.length == 0
                            ? 'transparent'
                            : pointSymbolBorderColour;
                    svg.style.strokeWidth = '5px';
                }
                pointStyleElement.find('.style-input').html(svg);
            }
        }
    },

    updateLineStyle(selectedFeature) {
        const lineStyleContainer = $('#line-style-config');
        const lineStyleCell = $(selectedFeature)
            .find('.layer-edit-field-feature-line-style')
            .parent();
        const lineSizeUnit =
            lineStyleContainer
                .find('.line-size-row')
                .find("input[name='size-unit']:checked")
                .val() === 'world units'
                ? 'm'
                : '';
        const linePattern = lineStyleContainer
            .find('.line-style-pattern-selected > span')
            .prop('class')
            .split('-')[0];
        const linePatternObj = $(lineStyleContainer.find('.line-style-pattern-selected').html());
        let lineColour = this.rgbToHex(
            lineStyleContainer
                .find('.line-style-colour-picker .picked-colour-blob')
                .css('background-color')
        );
        const lineSizeVal = lineStyleContainer
            .find('.line-size-row')
            .find("input[type='text']")
            .val();
        const lineSize = lineSizeVal.length > 0 ? lineSizeVal + lineSizeUnit : '';
        const lineBeginArrow =
            $('#arrow-begin-style-selected span').prop('class') === 'arrow-begin'
                ? 'arrow'
                : 'none';
        const lineEndArrow =
            $('#arrow-end-style-selected span').prop('class') === 'arrow-end' ? 'arrow' : 'none';

        // Update the style string in the line style table cell and fire an event with the updated string
        const lineStyleString = `${lineColour}:${lineSize}:${linePattern}:${lineBeginArrow}:${lineEndArrow}`;
        lineStyleCell.attr('data', lineStyleString);

        this.notify(lineStyleString, lineStyleCell);

        if (lineColour === 'none') {
            lineColour = 'transparent';
        }
        const lineBeginHtml =
                lineBeginArrow === 'arrow'
                    ? $("<span class='arrow-left'></span>")
                          .css('border-right-color', lineColour)
                          .prop('outerHTML')
                    : '',
            lineEndHtml =
                lineEndArrow === 'arrow'
                    ? $("<span class='arrow-right'></span>")
                          .css('border-left-color', lineColour)
                          .prop('outerHTML')
                    : '';

        linePatternObj.css('border-bottom-color', lineColour);
        lineStyleCell
            .find('.style-input')
            .html(lineBeginHtml + linePatternObj.prop('outerHTML') + lineEndHtml);
    },

    updatePolygonStyle(selectedFeature) {
        const polygonStyleContainer = $('#polygon-style-config'),
            borderSizeUnit =
                polygonStyleContainer
                    .find('.line-size-row')
                    .find("input[name='size-unit']:checked")
                    .val() === 'world units'
                    ? 'm'
                    : '',
            borderPattern = polygonStyleContainer
                .find('.line-style-pattern-selected > span')
                .prop('class')
                .split('-')[0],
            borderColour = this.rgbToHex(
                polygonStyleContainer
                    .find('.line-style-colour-picker .picked-colour-blob')
                    .css('background-color')
            ),
            borderSize =
                polygonStyleContainer
                    .find('.line-size-row')
                    .find("input[type='text']")
                    .val() + borderSizeUnit,
            polygonRepHeight = !borderSize || borderSize === '0' ? '15px' : '13px',
            fillColourBlob = $('#polygon-style-colour-picker .picked-colour-blob'),
            fillColour = this.rgbToHex(fillColourBlob.css('background-color')),
            fillAlpha = (fillColourBlob.css('opacity') * 100).toFixed(0),
            polygonStyleCell = $(selectedFeature)
                .find('.layer-edit-field-feature-polygon-style')
                .parent(),
            borderStyleString =
                !borderSize || borderSize === '0'
                    ? ''
                    : `${borderColour}:${borderSize}:${borderPattern}`,
            fillStyleString = fillColour === '' ? '#000000:0' : `${fillColour}:${fillAlpha}`;

        polygonStyleCell.attr('data', `${borderStyleString};${fillStyleString}`);
        this.notify({ lineStyle: borderStyleString, fillStyle: fillStyleString }, polygonStyleCell);

        const borderStyle =
            !borderSize || borderSize === '0' ? 'none' : `1px solid ${borderColour}`;

        polygonStyleCell
            .find('.polygon-representation')
            .css({ 'background-color': fillColour, opacity: fillAlpha / 100 })
            .show();

        polygonStyleCell
            .find('.polygon-rep-container')
            .show()
            .css({ border: borderStyle, height: polygonRepHeight });
    },

    updateTextStyle(selectedFeature) {
        const textAttrName = $('#text-attribute-name input').val(),
            textSizeUnit =
                $("#text-size-row input[name='size-unit']:checked").val() === 'world units'
                    ? 'm'
                    : '',
            textColour = this.rgbToHex(
                $('#text-style-colour-picker .picked-colour-blob').css('background-color')
            ),
            textSize = $("#text-size-row input[type='text']").val() + textSizeUnit,
            textVerticalAlign =
                $('#text-vertical-align select').val() +
                this._getOffsetString($('#text-vertical-align .offset-justification').val()),
            textHorizontalAlign =
                $('#text-horizontal-align select').val() +
                this._getOffsetString($('#text-horizontal-align .offset-justification').val()),
            textBackgroundColour = this.rgbToHex(
                $('#text-style-background-colour-picker .picked-colour-blob').css(
                    'background-color'
                )
            ),
            textBorderWidth = $('#text-border-width input').val(),
            minVis = $('.min-vis').val() || '',
            maxVis = $('.max-vis').val() || '',
            textStyleCell = $(selectedFeature)
                .find('.layer-edit-field-feature-text-style')
                .parent(),
            textStyleString = `${textAttrName}:${textColour}:${textSize}:${textVerticalAlign}:${textHorizontalAlign}:${textBackgroundColour}:${textBorderWidth}${
                minVis || maxVis ? ':' + minVis : ''
            }${minVis || maxVis ? ':' + maxVis : ''}`;

        const labelRepContainer = textStyleCell.find('.label-rep-container').show();
        const labelRep = textStyleCell.find('.label-representation').show();

        // Update the style string in the text style table cell and fire an event with the updated string
        textStyleCell.attr('data', textStyleString);

        this.notify(textStyleString, textStyleCell);

        if (!textBorderWidth || textBorderWidth === '0' || !textAttrName) {
            labelRepContainer.css('border-color', '');
        } else {
            labelRepContainer.css('border-color', textColour);
        }

        labelRep.css({ 'background-color': textBackgroundColour, color: textColour });
        labelRep.text(textAttrName);
    },

    notify(value, jQueryElement) {
        jQueryElement.trigger('style-changed', value);
        if (this.onChange) this.onChange(value);
    },

    /** Functions to enable/disable all but the attribute name on text style dialog */
    _disableTextStyle() {
        $('#text-style-not-attribute')
            .find('*')
            .addClass('text-style-disabled')
            .attr('disabled', 'disabled');
        $('#text-style-not-attribute')
            .find('.colour-picker')
            .spectrum({ disabled: true });
    },

    _enableTextStyle() {
        $('#text-style-not-attribute')
            .find('*')
            .removeClass('text-style-disabled')
            .removeAttr('disabled');

        // Need to do all of this again. Just switching disabled:false doesn't give
        // everything back
        this._initColourPicker();
        let textColour = $('#text-style-colour-picker')
            .children('.picked-colour-blob')
            .css('background-color');
        $('#text-style-colour-picker').spectrum('set', textColour);

        textColour = $('#text-style-background-colour-picker')
            .children('.picked-colour-blob')
            .css('background-color');
        $('#text-style-background-colour-picker').spectrum('set', textColour);
    },

    _checkDisabled(val) {
        if (val === '') this._disableTextStyle();
        else this._enableTextStyle();
    }
};

export default stylePicker;
